import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { View, Text } from "ui";
import ConfigureButton from "./ConfigureButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import _ from "lodash";
import { Checkbox, Dialog, withStyles } from "@material-ui/core";

export interface ContactItem {
  key: string;
  label: string;
}
interface P {
  title: string;
  open?: boolean;
  leftIcon: string;
  contacts: ContactItem[];
  selectedContacts: { [key: string]: boolean };
  onClose?: (selectedContacts: { [key: string]: boolean }) => void;
}

class ContactModal extends React.Component<P> {
  public state = {
    open: false,
    selectedContacts: this.props.selectedContacts || {}
  };

  public handleOpen = () => {
    this.setState({ open: true });
  }

  public handleClose = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose(this.state.selectedContacts);
    }
    this.setState({ open: false });
  }
  public handleClick = (contact: ContactItem) => {
    const { selectedContacts } = this.state;

    this.setState({
      selectedContacts: {
        ...selectedContacts,
        [contact.key]: !selectedContacts[contact.key]
      }
    });
  }

  public render() {
    const { contacts } = this.props;
    const { selectedContacts } = this.state;
    const selectedLength = _.values(selectedContacts).filter(c => c).length;

    return (
      <React.Fragment>
        <ConfigureButton
          leftIcon={this.props.leftIcon as any}
          title={this.props.title}
          rightIcon="list"
          rightText={`${selectedLength}`}
          onClick={this.handleOpen}
        />
        <Dialog open={this.state.open} onClose={this.handleClose}>
          <View bg="white" flexDirection="column" p={2}>
            <View
              m={1}
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="title" align="center">
                Alege:
              </Typography>
              <Button onClick={this.handleClose}>
                <Text fontSize={1}> x </Text>
              </Button>
            </View>
            <List>
              {contacts.map(item => (
                <ListItem
                  button
                  onClick={() => this.handleClick(item)}
                  key={item.key}
                >
                  <Checkbox
                    value={item.key}
                    checked={!!selectedContacts[item.key]}
                    color="default"
                  />
                  <ListItemText primary={item.label} />
                </ListItem>
              ))}
            </List>
          </View>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default ContactModal;



// WEBPACK FOOTER //
// ./src/components/ContactModal.tsx